import { makeStyles } from '@material-ui/styles';

export const useRadioOptionsStyles = makeStyles(() => ({
  radioButton: {
    '& span': {
      fontSize: 16,
    },
  },
  title: {
    color: '#464646',
    fontSize: '16px',
    marginBottom: 15,
    marginTop: (props) => (props.mobile ? 15 : 10),
    textAlign: (props) => (props.mobile ? 'center' : ''),
  },
  divider: {
    marginBottom: 15,
    marginTop: 15,
  },
}));
